import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DeviceBasic } from '../../../models/device-models/device-basic-model/device-basic.model';
import { BroadcastingInfo } from 'src/app/models/broadcastings-models/broadcasting-info.model';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcasting-devices-card',
  templateUrl: './broadcastings-broadcasting-devices-card.component.html',
  styleUrls: ['./broadcastings-broadcasting-devices-card.component.scss']
})
export class BroadcastingsBroadcastingDevicesCardComponent implements OnInit, OnDestroy {

  @Input() broadcasting: BroadcastingInfo;
  @Input() devices: Array<DeviceBasic>;
  selectedDevices;
  updateBroadcastingInfoSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  public duallistboxOutputEventReceiver(selectedDevices) {
    const aux = new Array();
    for (const d of selectedDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDevices = aux;
      this.updateBroadcastingDevices();
    }
  }

  public updateBroadcastingDevices() {
    this.updateBroadcastingInfoSubscription = this.broadcastingsService.updateBroadcastingDevices(this.broadcasting.BroadcastingInternalId, this.broadcasting.Active, this.broadcasting.ShowApp, this.selectedDevices).pipe(
      tap(o => this.broadcastingsService.refreshBroadcasting()),
      tap(o => this.snackbarService.open(o['message'], 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.updateBroadcastingInfoSubscription) { this.updateBroadcastingInfoSubscription.unsubscribe(); }
  }

}
